<!-- 
// Component: Title Bar
// Desc: Template
-->

<template>
  <div class="appTitleBar">
    <ov-icon
      class="appLogo"
      icon="logo/ov.png"
      :size="styles['titleBar']['logo_size']"
      @click="openURL('home')"
    >
      <ov-tooltip
        :tip="styles['titleBar']['logo_tooltip_tip']"
        :nudge-top="styles['titleBar']['logo_tooltip_nudge-top']"
        :nudge-left="styles['titleBar']['logo_tooltip_nudge-left']"
        :animation="styles['titleBar']['logo_tooltip_animation']"
        boundingTarget="idk"
      ></ov-tooltip>
    </ov-icon>
    <div class="smIconWrapper">
      <ov-icon
        v-for="(iconData, index) in externalLinks"
        :key="index"
        :icon="iconData.img"
        :size="styles['titleBar']['iconWrapper_icon-size']"
        @click="openURL(iconData.target)"
      >
        <ov-tooltip
          :tip="iconData.tip"
          :nudge-top="styles['titleBar']['iconWrapper_tooltip_nudge-top']"
          :animation="styles['titleBar']['iconWrapper_tooltip_animation']"
          boundingTarget="idk"
        ></ov-tooltip>
      </ov-icon>
    </div>
  </div>
</template>

<script>
import style_titleBar from "@/theme/components/titleBar/component.sass";
export default {
  data: () => ({
    styles: {
      titleBar: style_titleBar
    },
    //title: "OvileAmriam | عوايلأمريم",
    externalLinks: [
      {
        img: "externalLinks/github.svg",
        target: "https://github.com/OvileAmriam",
        tip: "Follow Us On Github!"
      },
      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },
      /*
      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },

      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },
      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },      {
        img: "externalLinks/discord.svg",
        target: "https://discord.gg/sVCnxPW",
        tip: "Join Us On Discord!"
      },
      */

      {
        img: "externalLinks/youtube.svg",
        target: "https://www.youtube.com/channel/UC3IB1JIkLAUjbXBTgDa0tyw",
        tip: "Subscribe Us On Youtube!"
      }
    ]
  }),
  methods: {
    openURL: function(url) {
      if (url != null) {
        open(url);
      }
    }
  }
};
</script>

<style scoped lang="sass">
@import "component.sass"
</style>
